import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiResponse } from "../../api/api";
import {
  GetTariffPlanChangeDetailsRequest,
  TariffPlanChangeDetailsResponse,
} from "../../interface/TariffPlanChangeContext";

export type GetTariffPlanChangeDetailsWithSignal =
  GetTariffPlanChangeDetailsRequest & { signal?: AbortSignal };

export const fetchTariffPlanChangeDetails = createAsyncThunk<
  ApiResponse<TariffPlanChangeDetailsResponse>,
  GetTariffPlanChangeDetailsWithSignal,
  { rejectValue: string }
>(
  "tariff/fetchTariffPlanChangeDetails",
  async (request, { rejectWithValue }) => {
    try {
      // Import service dynamically to avoid circular dependency
      const tariffService = await import("../../services/tariffService");
      return await tariffService.getTariffPlanChangeDetails(
        request,
        request.signal,
      );
    } catch (error) {
      return rejectWithValue(error as any);
    }
  },
);

export interface FetchTariffPlanChangeDetailsState {
  tariffPlanChangeDetails: ApiResponse<TariffPlanChangeDetailsResponse> | null;
  loading: boolean;
  error: string | null;
}

const initialState: FetchTariffPlanChangeDetailsState = {
  tariffPlanChangeDetails: null,
  loading: false,
  error: null,
};

const fetchTariffPlanChangeDetailsSlice = createSlice({
  name: "fetchTariffPlanChangeDetails",
  initialState,
  reducers: {
    resetTariffPlanChangeDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTariffPlanChangeDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTariffPlanChangeDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.tariffPlanChangeDetails = action.payload;
      })
      .addCase(fetchTariffPlanChangeDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
        state.tariffPlanChangeDetails = null;
      });
  },
});

export const { resetTariffPlanChangeDetails } =
  fetchTariffPlanChangeDetailsSlice.actions;
export default fetchTariffPlanChangeDetailsSlice.reducer;
